export type KlineDirection = 'up' | 'down' | 'equal'

export enum HandicapType {
  Buy = 'buy',
  Sell = 'sell',
  All = 'all',
}

export enum TradingViewResolution {
  /** 1分 */
  OneMinute = '1',
  /** 5分 */
  FiveMinutes = '5',
  /** 15分 */
  FifteenMinutes = '15',
  /** 30分 */
  ThirtyMinutes = '30',
  /** 1小时 */
  OneHour = '60',
  /** 4小时 */
  FourHour = '240',
  /** 1天 */
  OneDay = 'D',
  /** 1周 */
  OneWeek = 'W',
  /** 1月 */
  OneMonth = 'M',
}

export enum TradingViewResolutionKey {
  OneMinute = 1,
  FiveMinutes = 5,
  FifteenMinutes = 15,
  ThirtyMinutes = 30,
  OneHour = 60,
  FourHour = 240,
  OneDay = '1D',
  OneWeek = '1W',
  OneMonth = '1M',
}

export const ResolutionsMap = {
  [TradingViewResolutionKey.OneMinute]: TradingViewResolution.OneMinute,
  [TradingViewResolutionKey.FiveMinutes]: TradingViewResolution.FiveMinutes,
  [TradingViewResolutionKey.FifteenMinutes]: TradingViewResolution.FifteenMinutes,
  [TradingViewResolutionKey.ThirtyMinutes]: TradingViewResolution.ThirtyMinutes,
  [TradingViewResolutionKey.OneHour]: TradingViewResolution.OneHour,
  [TradingViewResolutionKey.FourHour]: TradingViewResolution.FourHour,
  [TradingViewResolutionKey.OneDay]: TradingViewResolution.OneDay,
  [TradingViewResolutionKey.OneWeek]: TradingViewResolution.OneWeek,
  [TradingViewResolutionKey.OneMonth]: TradingViewResolution.OneMonth,
}

export const HistoryKlineResolutionDiffMap = {
  [TradingViewResolutionKey.OneMinute]: 60,
  [TradingViewResolutionKey.FiveMinutes]: 5 * 60,
  [TradingViewResolutionKey.FifteenMinutes]: 15 * 60,
  [TradingViewResolutionKey.ThirtyMinutes]: 30 * 60,
  [TradingViewResolutionKey.OneHour]: 60 * 60,
  [TradingViewResolutionKey.FourHour]: 4 * 60 * 60,
  [TradingViewResolutionKey.OneDay]: 24 * 60 * 60,
  [TradingViewResolutionKey.OneWeek]: 7 * 24 * 60 * 60,
  [TradingViewResolutionKey.OneMonth]: 30 * 24 * 60 * 60,
}

export enum ResolutionType {
  /** K线 */
  Kline = 1,
  /** 分时 */
  KlineMinute = 3,
}

export type ResolutionItem = {
  label: string
  value: string
  type: number
}

export const resolutionList: ResolutionItem[] = [
  {
    label: '分时',
    value: TradingViewResolution.OneMinute,
    type: ResolutionType.KlineMinute,
  },
  {
    label: '1分钟',
    value: TradingViewResolution.OneMinute,
    type: ResolutionType.Kline,
  },
  {
    label: '5分钟',
    value: TradingViewResolution.FiveMinutes,
    type: ResolutionType.Kline,
  },
  {
    label: '15分钟',
    value: TradingViewResolution.FifteenMinutes,
    type: ResolutionType.Kline,
  },
  {
    label: '30分钟',
    value: TradingViewResolution.ThirtyMinutes,
    type: ResolutionType.Kline,
  },
  {
    label: '1小时',
    value: TradingViewResolution.OneHour,
    type: ResolutionType.Kline,
  },
  {
    label: '4小时',
    value: TradingViewResolution.FourHour,
    type: ResolutionType.Kline,
  },
  {
    label: '1天',
    value: TradingViewResolution.OneDay,
    type: ResolutionType.Kline,
  },
  {
    label: '1周',
    value: TradingViewResolution.OneWeek,
    type: ResolutionType.Kline,
  },
  {
    label: '1月',
    value: TradingViewResolution.OneMonth,
    type: ResolutionType.Kline,
  },
]

export const mobileResolutionList: ResolutionItem[] = [
  {
    label: '分时',
    value: TradingViewResolution.OneMinute,
    type: ResolutionType.KlineMinute,
  },
  {
    label: '15分',
    value: TradingViewResolution.FifteenMinutes,
    type: ResolutionType.Kline,
  },
  {
    label: '1小时',
    value: TradingViewResolution.OneHour,
    type: ResolutionType.Kline,
  },
  {
    label: '4小时',
    value: TradingViewResolution.FourHour,
    type: ResolutionType.Kline,
  },
  {
    label: '1天',
    value: TradingViewResolution.OneDay,
    type: ResolutionType.Kline,
  },
  {
    label: '1周',
    value: TradingViewResolution.OneWeek,
    type: ResolutionType.Kline,
  },
  {
    label: '1月',
    value: TradingViewResolution.OneMonth,
    type: ResolutionType.Kline,
  },
]

export enum UserDoubleContractUnitType {
  /** 币 */
  Coin = 'coin',
  /** USDT */
  USDT = 'usdt',
}
